import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@features/voucher-new/styles/voucher-new.module.css';
import { VoucherHeader } from '@features/voucher-new/ui/components/VoucherHeader';
import { useResponsive } from '@shared/hooks/useResponsive';
import { VoucherFooter } from '@features/voucher-new/ui/components/VoucherFooter';
import { ImageList } from '@shared/config/constants/Images';
import { useAtomValue } from 'jotai';

import { VoucherPinFormNew } from '@features/voucher-new/ui/components/VoucherPinFormNew';
import { languageAtom, voucherAtom } from '@shared/store/slice-atoms';
import { isRTL } from '@shared/utils/general';
import cn from 'classnames';

export const VoucherPinNew = () => {
  const { t } = useTranslation();
  const [isMobile] = useResponsive('MOBILE');

  const voucherRes = useAtomValue(voucherAtom).voucherRes as {
    email?: string;
    phoneNumber?: string;
  };

  const { direction } = useAtomValue(languageAtom);

  const isRTLDirection = isRTL(direction);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <VoucherHeader />

          {!isMobile ? (
            <img
              src={ImageList.voucherPreviewImage}
              alt="banner"
              className={styles.voucherBannerClassname}
            />
          ) : null}

          <div
            className={cn(
              styles.pinPageTextWrapper,
              isRTLDirection ? styles.pinPageTextWrapperRTL : ''
            )}
          >
            <p className={styles.voucherPinPageText}>{t('voucher_pin_page_title')}</p>

            <p className={styles.voucherPinDetailText}>{voucherRes.email || ''}</p>
            <p className={styles.voucherPinDetailText}>{voucherRes.phoneNumber || ''}</p>
          </div>

          <VoucherPinFormNew />
        </div>

        <VoucherFooter />
      </div>
    </div>
  );
};
